<template>
    <app-layout>
        <template #header>
            <div class="max-w-5xl mx-auto text-center text-lg px-4 py-4 bg-yellow-200 mb-4">
                <b>Bestellung für den {{ $page.props.formattedOrderDate }} nicht möglich:</b> <br>
                <p v-if="!$page.props.isInAllowedWeekday">Wir liefern an dem ausgewählten Wochentag nicht.</p>
                <p v-if="!$page.props.leadTimeIsMet">Wir nehmen Bestellungen nur mit 2 Werktagen Vorlaufzeit, bis 12 Uhr entgegen (Uhrzeit kann abweichen).</p>
                <p v-if="$page.props.excludedDay">Wir liefern an diesem Tag nicht</p>
            </div>
        </template>
    </app-layout>
</template>

<script>
    import AppLayout from '@/Layouts/AppLayout'

    export default {
        components: {
            AppLayout,
        },
    }
</script>
